import { AccountAiSettings } from '@superfunnel/types';
import { doc } from 'firebase/firestore';
import { db } from '../Firebase';
import { emptyConverter } from '../utils';

export const getAccountAiSettingsDocRef = (accountId: string) =>
  doc(db, 'accounts', accountId, 'accountAiSettings', 'default').withConverter(
    emptyConverter<AccountAiSettings>(),
  );
